export default "__VITE_ASSET__DfbKsFDI__"